<div fxLayout="row" class="background">
    <div fxFlex="95" fxFlexOffset="2%">

        <section id="header">
            <h1 class="h1Header">REPORTE DE CADETES</h1>
        </section>
        
        <form [formGroup]="deliveryReportForm">
            <div class="formulario">
              <mat-card>
                <div fxLayout="row" fxLayoutAlign="start center">
                  <button fxFlex="10" mat-raised-button>Pedidos</button>
                  <button fxFlex="10" mat-raised-button>Strike</button>
              </div>
                <div fxLayout="row" fxLayoutAlign="space-evenly center">
                    <div fxFlex="15">
                        <mat-form-field appearance="outline">
                          <mat-label>Cadete</mat-label>
                          <mat-select>
                            <mat-option value="one">Todos</mat-option>
                            <mat-option value="two">Cadete 1</mat-option>
                            <mat-option value="three">Cadete 2</mat-option>
                          </mat-select>
                        </mat-form-field>
                    </div>
                  <div fxFlex="15">
                    <mat-form-field appearance="outline">
                      <mat-label>Fecha Desde</mat-label>
                        <input matInput [matDatepicker]="calendario" formControlName="fechaDD" readonly>
                        <mat-datepicker-toggle matSuffix [for]="calendario"></mat-datepicker-toggle>
                        <mat-datepicker #calendario></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div fxFlex="15">
                    <mat-form-field appearance="outline">
                      <mat-label>Fecha Hasta</mat-label>
                      <input matInput [matDatepicker]="calendar" formControlName="fechaHD" readonly>
                        <mat-datepicker-toggle matSuffix [for]="calendar"></mat-datepicker-toggle>
                        <mat-datepicker #calendar></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div fxFlex="15">
                    <mat-form-field appearance="outline">
                      <mat-label>Estado</mat-label>
                      <mat-select>
                        <mat-option value="one">Todos</mat-option>
                        <mat-option value="two">Asignado a Cadete</mat-option>
                        <mat-option value="three">En viaje</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  
                </div>
                <div fxLayout="row" fxLayoutAlign="space-evenly center">
                    <button fxFlex="15" mat-raised-button>Buscar</button>
                    <button fxFlex="15" mat-raised-button (click)="exporter.exportTable('xlsx')">Exportar Excel</button>
                </div>
            </mat-card>
        </div>
        </form>

        <div fxLayout="row" class="tablaD">
            <div fxFlex=100 fxFlexOffset="-15%">
              <mat-card class="mat-elevation-z0">
                <table mat-table matTableExporter [dataSource]="dataSource" #exporter="matTableExporter" class="tabla">
                 
                  
                  <!-- nombre Column -->
                  <ng-container matColumnDef="nombre">
                    <th mat-header-cell *matHeaderCellDef> NOMBRE</th>
                    <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                  </ng-container>


                   <!-- idP Column -->
                   <ng-container matColumnDef="idP">
                    <th mat-header-cell *matHeaderCellDef> ID_PEDIDO </th>
                    <td mat-cell *matCellDef="let element">{{element.idP}}</td>
                  </ng-container>
          
                  <!-- fechaP Column -->
                  <ng-container matColumnDef="fechaP">
                    <th mat-header-cell *matHeaderCellDef> FECHA PEDIDO </th>
                    <td mat-cell *matCellDef="let element"> {{element.fechaP}} </td>
                  </ng-container>
          
                  <!-- dirP Column -->
                  <ng-container matColumnDef="dirP">
                    <th mat-header-cell *matHeaderCellDef> DIR. PEDIDO</th>
                    <td mat-cell *matCellDef="let element">{{element.dirP}}</td>
                  </ng-container>
                  
                   <!-- total Column -->
                   <ng-container matColumnDef="total">
                    <th mat-header-cell *matHeaderCellDef> TOTAL</th>
                    <td mat-cell *matCellDef="let element"> {{element.total}} </td>
                  </ng-container>

                  <!-- neto Column -->
          
                  <ng-container matColumnDef="neto">
                    <th mat-header-cell *matHeaderCellDef>NETO</th>
                    <td mat-cell *matCellDef="let element">{{element.neto}}</td>
                  </ng-container>
          
                  <!-- envio Column -->
          
                  <ng-container matColumnDef="envio">
                    <th mat-header-cell *matHeaderCellDef>ENVÍO</th>
                    <td mat-cell *matCellDef="let element">{{element.envio}}</td>
                  </ng-container>


                  <!-- estado Column -->
          
                  <ng-container matColumnDef="estado">
                    <th mat-header-cell *matHeaderCellDef>ESTADO</th>
                    <td mat-cell *matCellDef="let element">{{element.estado}}</td>     
                  </ng-container>

                  <!-- comision Column -->
          
                  <ng-container matColumnDef="comision">
                    <th mat-header-cell *matHeaderCellDef>COMISIÓN</th>
                    <td mat-cell *matCellDef="let element">{{element.comision}}</td>    
                  </ng-container>

                  <!-- liquidacion Column -->
          
                  <ng-container matColumnDef="liquidacion">
                    <th mat-header-cell *matHeaderCellDef>LIQ.</th>
                    <td mat-cell *matCellDef="let element">{{element.liquidacion}}</td>  
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          
                </table>
              </mat-card>
            </div>
        </div>

    </div>
</div>